module.exports = __webpack_public_path__ + "static/Q1_2022_Investor_Presentation-f6deb2e4db1f1bcce036eb6ba3f98afa.pdf";